import { hsl } from 'polished';
export default {
    primary: {
        /** Hex: #262626 */
        base: '#262626',
        purple: {
            /** Hex: #5A0066 */
            base: '#5A0066',
            /** Hex: #80118F */
            light: '#80118F',
            /** Hex: #480051 */
            mid: '#480051',
            /** Hex: #2A032F */
            dark: '#2A032F',
        },
    },
    secondary: {
        pink: {
            /** Hex: #FE5AB6 */
            lightest: '#FE5AB6',
            /** Hex: #DC007D */
            light: '#DC007D',
            /** Hex: #AD0262 */
            dark: '#AD0262',
        },
        blue: {
            /** Hex: #7AC3E2 */
            light: '#7AC3E2',
            /** Hex: #0066AB */
            dark: '#0066AB',
        },
        grey: {
            /** Hex: #EBE7F2 */
            light: '#EBE7F2',
            /** Hex: #747679 */
            dark: '#747679',
        },
    },
    tertiary: {
        teal: {
            /** Hex: #026D79 */
            light: '#026D79',
            /** Hex: #018d9d */
            mid: '#018d9d',
            /** Hex: #028298 */
            dark: '#028298',
        },
        green: {
            /** Hex: #92BC31 */
            light: '#92BC31',
            /** Hex: #307532 */
            dark: '#307532',
        },
        /** Hex: #C45300 */
        orange: '#C45300',
        /** Hex: #c24C81 */
        pink: '#c24C81',
        yellow: {
            /** Hex: #E5E597 */
            light: '#E5E597',
            /** Hex: #c6c686 */
            dark: '#c6c686',
        },
        nearlyWhite: {
            /** Hex: #F3F3F3 */
            light: '#F3F3F3',
            /** Hex: #EEEEEE */
            mid: '#EEEEEE',
        },
    },
    global: {
        /** Hex: #000000 */
        black: '#000',
        /** Hex: #ffffff */
        white: '#fff',
    },
    validation: {
        /** Hex: #307532 */
        valid: '#307532',
        /** Hex: #dd3a25 */
        invalid: '#dd3a25',
    },
    grey: {
        /** Hex: #222222 */
        grey13: hsl(0, 0, 0.13),
        /** Hex: #585858 */
        grey20: hsl(0, 0, 0.2),
        /** Hex: #585858 */
        grey35: hsl(0, 0, 0.35),
        /** Hex: #666666 */
        grey40: hsl(0, 0, 0.4),
        /** Hex: #707070 */
        grey44: hsl(0, 0, 0.44),
        /** Hex: #999999 */
        grey60: hsl(0, 0, 0.6),
        /** Hex: #CCCCCC */
        grey80: hsl(0, 0, 0.8),
        /** Hex: #E5E5E5 */
        grey90: hsl(0, 0, 0.9),
        /** Hex: #F7F7F7 */
        grey97: hsl(0, 0, 0.97),
    },
    /** Hex: #741669 */
    logo: '#741669',
};
